import * as Yup from 'yup';


export class Dto{
  data: any;
  private submitted: boolean;
  private _handleOnSubmit: (values:any) => void = (values:any) => {};
  protected _handleOnSubmitCustom: (values:any,path:string,method?:string) => void = (values:any) => {};
  constructor(){

    Yup.addMethod(Yup.object, "ObjectNotEmpty", function (errorMessage) {
      return this.test(`object-not-empty`, errorMessage, function (value) {
        console.log(value);
        const { path, createError } = this;
    
        return (
          (value && value.length === 16) ||
          createError({ path, message: errorMessage })
        );
      });
    });

    
    
    this.data = {}
    this.data.initialValues = {};
    this.data.validationSchema = {}
    this.submitted = false;
    this.data.onSubmit = async (values: any) => {
      let result = await this._handleOnSubmit(values);
      return result;
    }
  }

  updateData(data){
    for(let key in this.data.initialValues){
      if(data.data[key] !== undefined){
        this.data.initialValues[key] = data.data[key];
      }
    }
  }
  handleOnSubmit =  (callback  : (values:any) => void) => {
    this._handleOnSubmit = callback;
  }

  handleOnSubmitCustom =  (callback: (values: any, path: string, method?: string) => void) => {
    this._handleOnSubmitCustom = callback;
  }

  
  hookIsEdit = () => {

  }
 
  get isSubmitted(){
    return this.submitted;
  }
}